import { autoinject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { WidgetController } from 'controls/as-widget-container';
import { AirlineDeviationDetail } from 'model/forms/deviation-request';
import { LookupsService } from 'services/lookups-service';
import { WidgetBase } from 'support/base_classes/widget-base';

@autoinject
export class AirlineDeviationDetailWidget extends WidgetBase<AirlineDeviationDetail, WidgetController> {
  constructor(private lookups: LookupsService) {
    super();
  }

  changed() {
    ValidationRules
      .ensureObject<AirlineDeviationDetail>().required()
      .ensure(model => model.airlineCustomName).displayName('Airline').required()
      .on(this.model);
  }

  airlinesLookupOptions = this.lookups.getAirlinesLookupOptions();
}
